/**
 * Shared helpers for the chat subcomponents.
 *
 * Extracted from AIChat.js so MessageBubble, ToolCard, TripSummaryCard
 * etc. can render dates and badge colours consistently without dragging
 * the formatting logic across files.
 */

/**
 * Render a "15–20 Jun 2026" style range, or "Mon 15 Jun" for one-way trips.
 * Locale-aware (EN/BG). Falls back gracefully if dates are invalid.
 */
export function formatDateRange(start, end, lang) {
  if (!start) return '';
  const locale = lang === 'bg' ? 'bg-BG' : 'en-GB';
  const d1 = new Date(start);
  if (Number.isNaN(d1.getTime())) return '';
  if (!end) {
    return d1.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });
  }
  const d2 = new Date(end);
  if (Number.isNaN(d2.getTime())) {
    return d1.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
  }
  const sameMonth = d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
  if (sameMonth) {
    const day1 = d1.toLocaleDateString(locale, { day: 'numeric' });
    const day2End = d2.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
    return `${day1}–${day2End}`;
  }
  const left = d1.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
  const right = d2.toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
  return `${left} → ${right}`;
}

/** Tier → badge colours for budget/standard/luxury chips. */
export function getBadgeColor(type) {
  switch (type) {
    case 'budget':
      return 'bg-green-100 text-green-800 border-green-300';
    case 'standard':
      return 'bg-blue-100 text-blue-800 border-blue-300';
    case 'luxury':
      return 'bg-blue-100 text-blue-900 border-blue-300';
    default:
      return 'bg-gray-100 text-gray-800 border-gray-300';
  }
}
